import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=61da1686&scoped=true&"
import script from "./Administration.vue?vue&type=script&lang=js&"
export * from "./Administration.vue?vue&type=script&lang=js&"
import style0 from "./Administration.vue?vue&type=style&index=0&id=61da1686&lang=scss&scoped=true&"
import style1 from "./Administration.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61da1686",
  null
  
)

export default component.exports